import { styled } from '@mui/system';

export const CorrectAnswerNotice = styled('div')(props => ({
  color: props.theme.palette.success.main
}));
